import { taxonomyLookupModalReducerKey } from './TaxonomyLookupModalConstants';

export const taxonomyLookupModal = (state) => state.get(taxonomyLookupModalReducerKey);

export const isLoading = (state) => taxonomyLookupModal(state).get('isLoading');
export const opModel = (state) => taxonomyLookupModal(state).get('opModel');

export const suggestConfig = (state) => taxonomyLookupModal(state).get('suggestConfig');

export const boundOperator = (state) => taxonomyLookupModal(state).get('boundOperator');

export const search = (state) => taxonomyLookupModal(state).get('search');

export const selectedItems = (state) => taxonomyLookupModal(state).get('selectedItems');

export const totalHitCount = (state) => taxonomyLookupModal(state).get('totalHitCount');

export const transferEnabled = (state) => taxonomyLookupModal(state).get('transferEnabled');
